module.exports = "/static/assets/d84cdb7f4b9567882511ab47f63e342b.svg";